import * as types from '../../actions/actionTypes';
import initialState from './../initialState';


export default function galleriesReducer(state = initialState.galleries, action) {
    let newState;

    switch (action.type) {
        case types.LOAD_GALLERIES_SUCCESS:
            return action.galleries;
            break;
        case types.CREATE_GALLERY_SUCCESS:
            return {...state};
            break;
        case types.UPDATE_GALLERY_SUCCESS:
            let galleryData = [
                ...state.data.filter(gallery => gallery.id !== action.gallery.id),
                {...action.galleries}
            ];

            return {
                ...state,
                data: [...galleryData]
            };
            break;
        case types.DELETE_GALLERY_SUCCESS:
            newState = {...state};
            newState.data = state.data.filter(gallery => gallery.id !== action.id);
            newState.total = state.total -1;
            return newState;
            break;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./web/src/reducers/gallery/galleriesReducer.js